import { render, staticRenderFns } from "./acquiringTransactionTypes.vue?vue&type=template&id=776d9932"
import script from "./acquiringTransactionTypes.vue?vue&type=script&lang=js"
export * from "./acquiringTransactionTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports